import { useMutation, useQueryClient } from "@tanstack/react-query";

import http from "../../../http";
import { DELETE_PAYMENT_ACCOUNT, GET_PAYMENT_ACCOUNTS } from "../../URL";
import { IAxisErrorResponse } from "../../../interfaces";

const deletePaymentAccount = async (paymentAccountID: string) => {
  await http.post(DELETE_PAYMENT_ACCOUNT, {
    paymentAccountID,
  });
};

const useDeletePaymentAccount = () => {
  const queryClient = useQueryClient();  // PR 7831723 

  return useMutation<void, IAxisErrorResponse, string>({
    mutationKey: ["delete-payment-account"],
    mutationFn: deletePaymentAccount,
    // PR 7831723 Start
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["payment-accounts"] });
      queryClient.invalidateQueries({
        queryKey: ["grid", GET_PAYMENT_ACCOUNTS],
      });
    },
    // PR 7831723 End
  });
};

export default useDeletePaymentAccount;
